<template>
  <div class="page-content">
    <el-title :index="index + 1" :parent_data="active_study.etudeData.gie.sectionCaracteristiquesResidence"
					property="titre"
					:editable="true" style="margin-bottom: 5px">
			Caractéristiques et standing de la résidence&nbsp;:
		</el-title>

    <div>
      <section-gie-flash-caracteristique-standing/>
    </div>

    <el-title :index="index + 2" :parent_data="active_study.etudeData.gie.sectionDynamiqueMarcheResidentiel"
					property="titre"
					:editable="true" style="margin-bottom: 5px">
			Dynamique du marché résidentiel&nbsp;:
		</el-title>

    <div>
      <p class="label-small flex">
        Marché locatif&nbsp;:&nbsp;
        <el-textarea
          :parent_data="
            active_study.etudeData.gie.sectionDynamiqueMarcheResidentiel
          "
          property="titre_marche_locatif"
          :editable="true"
          placeholder="Modifier le titre..."
          class="textarea-title"
          :max-length="120"
          style="flex: 1 1 auto"
        />
      </p>

      <section-situation-marche-locatif
      :livraisonsQlikComponentId="null"
      :evolutionLoyerQlikComponentName="'loyers1'"
      :ratioDynamismeQlikComponentName="'dynamisme construction locative libre'"
      :kpiQlikComponentName="'loyers2'"
      :evolutionLoyerQlikComponentId="'4.1'"
      :ratioDynamismeQlikComponentId="'4.2'"
      :kpiQlikComponentId="'4.3'"
        v-slot="{
          ratio_dynamisme_periode_passee,
          chart_evolution_loyers,
          evolution_loyer_chart_key,
          liste_kpi,
        }"
      editModeTheme="dynamique_marche_residentiel_locatif"
      >
        <div class="tle-row condensed">
          <div class="tle-col two-fifth">
            <chart-evolution-loyer
              :chart_evolution_loyers="chart_evolution_loyers"
              :evolution_loyer_chart_key="evolution_loyer_chart_key"
              :dense="true"
            />
          </div>
          <div class="tle-col three-fifth">
            <div class="tle-row condensed">
              <div class="tle-col two-third">
                <dynamisme-construction-locative
                  :ratio_dynamisme_periode_passee="
                    ratio_dynamisme_periode_passee
                  "
                  :dense="true"
                  class="q-mb-md q-mr-md"
                />
              </div>
              <div
                class="tle-col one-third"
                v-for="(square, i) in liste_kpi"
                :key="'kpi' + i"
              >
                <el-square
                  :parent_data="square"
                  property="value"
                  :label="square.label"
                  :format="square.label.toLowerCase() == 'zonage pinel' || square.label.toLowerCase() == 'zonage locatif social' ? 'string' : 'number'"
                  :sub_value="{ value: square.legend }"
                  :suffix="square.unit"
                  :editable="square.label.toLowerCase() == 'zonage pinel' || square.label.toLowerCase() == 'loyer pinel (su)'"
                />
              </div>
            </div>
          </div>
        </div>
      </section-situation-marche-locatif>
    </div>

    <div style="margin-top: -15px">
      <p class="label-small flex">
        {{last_year_periodTitle}}&nbsp;
        <el-textarea
          :parent_data="
            active_study.etudeData.gie.sectionDynamiqueMarcheResidentiel
          "
          property="titre_marche_promotion"
          :editable="true"
          placeholder="Modifier le titre..."
          class="textarea-title"
          :max-length="120"
          style="flex: 1 1 auto"
        />
      </p>

      <section-marche-promotion-immobiliere
        theme="dynamique_marche_residentiel_promotion"
        :kpiQlikComponentName="'volume activite et prix vente'"
        :kpiQlikComponentId="'4.4'"
        :show-last-section="false"
        v-slot="{ list_kpi }"
      >
        <div class="tle-row">
          <div class="tle-col three-fifth">
            <p class="label --medium main_color_text">Volumes d’activité et prix de vente</p>
            
            <div :class="{ 'can-change': editor.mode == 'editing' }">
              <!-- <el-keypoints /> -->
              <div class="tle-row condensed">
                <div
                  v-for="(kpi, i) in list_kpi.table"
                  :key="'kpi-first-' + i"
                  class="tle-col"
                  :class="[i < 3 ? 'one-third' : 'half']"
                >
                  <el-square
                    :parent_data="kpi.parent_data"
                    :property="kpi.property"
                    :suffix="kpi.unit"
                    :label="kpi.header"
                    :sub_value="{value: { parent_data: kpi.sub.parent_data, property: kpi.sub.property }, suffix: kpi.sub.suffix}"
                    format="string"
                  />
                </div>
              </div>
              <!-- Display error div -->
              <error v-if="list_kpi.error" show-in-read-mode />
            </div>
          </div>
          <div class="tle-col two-fifth">
            <div class="tle-row condensed">
              <div class="tle-col one-third">
                <chart-acquereur />
              </div>
              <div class="tle-col two-third">
                <chart-financement />
              </div>
            </div>
          </div>
        </div>
      </section-marche-promotion-immobiliere>
    </div>
    <p class="label main_color_text">Marché de la revente</p>
      <section-marche-revente />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import PageMixin from "@/components/study/editor/pages/page.mixin.js";
import sectionSituationMarcheLocatif from "@/components/study/editor/pages/sections/section-situation-marche-locatif";
import sectionMarchePromotionImmobiliere from "@/components/study/editor/pages/sections/section-marche-promotion-immobiliere";
import dynamismeConstructionLocative from "@/components/study/editor/elements/data/dynamisme-construction-locative";
import chartEvolutionLoyer from "@/components/study/editor/elements/data/chart-evolution-loyer";
import chartFinancement from "@/components/study/editor/elements/data/chart-financement";
import chartAcquereur from "@/components/study/editor/elements/data/chart-acquereur";
import error from "@/components/global/error.vue";
import getParameter from "@/libs/get_parameter.js";
import sectionGieFlashCaracteristiqueStanding from "@/components/study/editor/pages/sections/section-gie-flash-caracteristique-standing.vue";
import sectionMarcheRevente from "@/components/study/editor/pages/sections/section-marche-revente";

export default {
	components: {
		sectionSituationMarcheLocatif,
		sectionMarchePromotionImmobiliere,
		dynamismeConstructionLocative,
		chartEvolutionLoyer,
		chartFinancement,
		chartAcquereur,
		error,
		sectionGieFlashCaracteristiqueStanding,
		sectionMarcheRevente,
	},
	name: "page-gie-2",
	mixins: [PageMixin],
	data: function () {
		return {
			form: {},
			themePromo: "dynamique_marche_residentiel_promotion"
		};
	},
	props: ["index"],
	computed: {
		...mapGetters([
			"active_study",
			"app_parameters",
			"editor",
			"etude_data"
		]),
		parameters () {
			return this.active_study.qlikData.parameters.editmode.find((editmode) => {
				return editmode.theme == this.themePromo;
			});
		},
		last_year_period () {
			return this.getParameter("lastYearPeriod", this.parameters.periods.values[0].code);
		},
		last_year_periodTitle () {
      try{
        const currentPeriod = this.parameters.periods.values.find((value) => {
          return value.code == this.last_year_period;
        });
        return currentPeriod.title;
      }catch(e){
        return "Marché de la promotion immobilière :";
      }
		},
	},
	methods: {
		getParameter (name, defaultValue) {
			return getParameter(this.etude_data, this.themePromo, name, defaultValue);
		}
	}
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app';
@import '../../../../assets/css/page';

</style>
